const NORMAL_LEFT = ["#6a0000", "#b50000", "#ff0000", "#ff5151", "#ff9999"];
const NORMAL_RIGHT = ["#9cff9c", "#51ff51", "#00ff00", "#00b500", "#006a00"];

const REVERSE_LEFT = ["#006a00", "#00b500", "#00ff00", "#51ff51", "#9cff9c"];
const REVERSE_RIGHT = ["#ff9999", "#ff5151", "#ff0000", "#b50000", "#6a0000"];

const REVERSE_SCALE = ["dom_growth_months", "days_on_market_mean"];
function calculateMedian(sortedValues) {
  const n = sortedValues.length;
  const middle = Math.floor((n - 1) / 2);

  if (n % 2 === 0) {
    // even number of elements — average the two middle values
    return Math.round((sortedValues[middle] + sortedValues[middle + 1]) / 2);
  } else {
    // odd — middle value directly
    return sortedValues[middle];
  }
}
export const generateDOMRange = (data, type,geoData={}) => {
  let latitude = 0;
  let longitude = 0;

  if (!Array.isArray(data) || data.length === 0) {
    return { latitude, longitude, min: 0, max: 0, median: 0, range: [], colorRange: [] };
  }
  const geoKeys = geoData ? Object.keys(geoData) : [];


  const validValues = data
    .filter(d => geoKeys.includes(d.zcta5ce20))  // filter only if geo key exists
    .map(d => parseFloat(d[type]))
    .filter(v => !isNaN(v))
    .sort((a, b) => a - b);

  if (validValues.length === 0) {
    return { latitude, longitude, min: 0, max: 0, median: 0, range: [], colorRange: [] };
  }

  const min = Math.floor(validValues[0]);
  const max = Math.ceil(validValues[validValues.length - 1]);
  const median = calculateMedian(validValues);

  const location = data.find(d => d && Math.ceil(d.distance_from_factory_centre1) === 0);
  if (location) {
    latitude = location.latitude;
    longitude = location.longitude;
  }

  const { range, colorsRange } = getFinalDOMRangeLegend(min, median, max, type);

  return {
    latitude,
    longitude,
    min,
    max,
    median,
    range,
    colorRange: colorsRange,
  };
};




const getFinalDOMRangeLegend = (min, median, max, type) => {
  let range = [];
  let colorsRange = [];

  const isReversed = REVERSE_SCALE.includes(type);

  const leftPalette = isReversed ? REVERSE_LEFT : NORMAL_LEFT;
  const rightPalette = isReversed ? REVERSE_RIGHT : NORMAL_RIGHT;

  const stepsLeft = leftPalette.length;
  const stepsRight = rightPalette.length;

  const leftStep = (median - min) / stepsLeft;
  for (let i = 0; i < stepsLeft; i++) {
    const val = Math.round(min + i * leftStep);
    range.push(val);
    colorsRange.push([val, leftPalette[i]]);
  }

  // median - white
  range.push(median);
  colorsRange.push([median, "#FFFFFF"]);

  const rightStep = (max - median) / stepsRight;
  for (let i = 1; i <= stepsRight; i++) {
    const val = Math.round(median + i * rightStep);
    range.push(val);
    colorsRange.push([val, rightPalette[i - 1]]);
  }

  range = [...new Set(range)].sort((a, b) => a - b);
  colorsRange = Array.from(new Map(colorsRange.map(([v, c]) => [v, c])).entries()).map(([v, c]) => [v, c]);

  return { range, colorsRange };
};

export const getDOMColor = (min, max, actualValue, type,data,geoData={}) => {
  if (actualValue === null || actualValue === undefined) return "#FFFFFF";
  const num = parseFloat(actualValue);
  if (isNaN(num)) return "#FFFFFF";
  const geoKeys = geoData ? Object.keys(geoData) : [];

  const validValues = data
    .filter(d => geoKeys.includes(d.zcta5ce20))  // filter only if geo key exists
    .map(d => parseFloat(d[type]))
    .filter(v => !isNaN(v))
    .sort((a, b) => a - b);


  const median = calculateMedian(validValues);
  const isReversed = REVERSE_SCALE.includes(type);

  const leftPalette = isReversed ? REVERSE_LEFT : NORMAL_LEFT;
  const rightPalette = isReversed ? REVERSE_RIGHT : NORMAL_RIGHT;

  if (num === median) return "#FFFFFF";

  if (num < median) {
    const ratio = (num - min) / (median - min);
    const idx = Math.min(leftPalette.length - 1, Math.floor(ratio * leftPalette.length));
    return leftPalette[idx];
  } else {
    const ratio = (num - median) / (max - median);
    const idx = Math.min(rightPalette.length - 1, Math.floor(ratio * rightPalette.length));
    return rightPalette[idx];
  }
};



const COLORS = [
  "#6a0000",
  "#b50000",
  "#ff0000",
  "#ff5151",
  "#fff",
  "#9cff9c",
  "#51ff51",
  "#00ff00",
  "#00b500",
  "#006a00",
  "#004e00",
];

const PROFITABLE_COLORS = [
  "#fff",
  "#E6FF9A",
  "#DBFF73",
  "#CCFF57",
  "#B2EE45",
  "#9DD225",
  "#7EFF00",
  "#46C24C",
  "#469F77",
  "#006a00",
  "#004e00",
];

const sortByRange = (a, b) => a[0][0] - b[0][0];



export const generateDataRange = (data, type, geoData) => {
  let distance;
  if (data.length) {
    let latitude = data[0].latitude;
    let longitude = data[0].longitude;
    if (type === "high_expected_returns") {
      distance = data.find(
        (d) => d && Math.ceil(d.distance_from_factory_centre1) === 0
      );
    }
    if (distance) {
      latitude = distance.latitude;
      longitude = distance.longitude;
    }

    // Filter data based on geoData keys
    const filteredValues = data
      .filter((o) => o.zcta5ce20 && geoData.hasOwnProperty(o.zcta5ce20))
      .map((o) => o[type])
      .filter((val) => val !== undefined && val !== null); // avoid undefined/null values

    let max = 0, min = 0;
    if (filteredValues.length > 0) {
      max = parseFloat(Math.max(...filteredValues));
      min = parseFloat(Math.min(...filteredValues));
    }

    const range = getFinalRangeLegend(min, max, type, false);

    return {
      latitude,
      longitude,
      max,
      min,
      range: range.range,
      colorRange: range.colorsRange,
    };
  } else {
    return {
      latitude: 0,
      longitude: 0,
      max: 0,
      min: 0,
      range: [],
    };
  }
};


const RED_COLORS = [
  "#6a0000",
  "#b50000",
  "#ff0000",
  "#ff5151", // Red shades for negative values
];

const GREEN_COLORS = [
  "#9cff9c",
  "#51ff51",
  "#00ff00",
  "#00b500",
  "#006a00",
  "#004e00", // Green shades for positive values
];

const RED_PALETTE = ["#ffcccc", "#ff9999", "#ff6666", "#ff3333", "#ff0000", "#cc0000"];
const GREEN_PALETTE = ["#ccffcc", "#99ff99", "#66ff66", "#33cc33", "#00cc00", "#009900"];

// Updated range generator
const generateRange = (min, max, n) => {
  const delta = (max - min) / n;
  const ranges = [];
  let range1 = min;

  for (let i = 0; i <= n; i += 1) {
    if (range1 <= 1 && range1 >= -1) {
      ranges.push(parseFloat(range1.toFixed(2)));
    } else {
      ranges.push(parseInt(range1));
    }
    range1 += delta;
  }

  return ranges;
};

// Main function to generate legend
export const getFinalRangeLegend = (min, max, type) => {
  const isReversed = REVERSE_SCALE.includes(type);
  const range = generateRange(min, max, 10); // 11 buckets

  if (min >= 0 && !isReversed) {
    const colorsRange = range.map((value, idx) => [
      value,
      PROFITABLE_COLORS[Math.min(idx, PROFITABLE_COLORS.length - 1)]
    ]);
    return { range, colorsRange };
  }

  let zeroIndex = range.findIndex(val => val >= 0);
  if (zeroIndex === -1) zeroIndex = range.length;

  const leftBuckets = zeroIndex;
  const rightBuckets = range.length - zeroIndex - 1;

  let leftColors = [];
  let rightColors = [];

  if (!isReversed) {
    // Normal scale
    for (let i = 0; i < leftBuckets; i++) {
      const index = Math.floor(i * (RED_PALETTE.length / leftBuckets));
      leftColors.unshift(RED_PALETTE[index]);
    }
    for (let i = 0; i < rightBuckets; i++) {
      const index = Math.floor(i * (GREEN_PALETTE.length / rightBuckets));
      rightColors.push(GREEN_PALETTE[index]);
    }
  } else {
    // Reverse scale
    for (let i = 0; i < leftBuckets; i++) {
      const index = Math.floor(i * (GREEN_PALETTE.length / leftBuckets));
      leftColors.unshift(GREEN_PALETTE[index]);
    }
    for (let i = 0; i < rightBuckets; i++) {
      const index = Math.floor(i * (RED_PALETTE.length / rightBuckets));
      rightColors.push(RED_PALETTE[index]);
    }
  }

  const shiftedColors = [...leftColors, "#fff", ...rightColors];
  const colorsRange = range.map((value, idx) => [value, shiftedColors[idx] || "#fff"]);

  return { range, colorsRange };
};

// Map actualValue to color
export const getColor = (min, max, actualValue, type) => {
  const { colorsRange } = getFinalRangeLegend(min, max, type);

  if (actualValue <= colorsRange[0][0]) {
    return colorsRange[0][1];
  }
  if (actualValue >= colorsRange[colorsRange.length - 1][0]) {
    return colorsRange[colorsRange.length - 1][1];
  }

  for (let i = 1; i < colorsRange.length; i++) {
    if (actualValue < colorsRange[i][0]) {
      return colorsRange[i - 1][1];
    }
  }

  return colorsRange[colorsRange.length - 1][1];
};





export const flatten = (arr) => {
  if (arr.length === 1) return flatten(arr[0]);
  else return arr;
};

export const generatePopupContent = (
  event,
  type,
  selectedQuarter,
  selectedMonth,
  email
) => {
  const isExpectedReturnSelected = type === "high_expected_returns";
  const isDaysOnMarketSelected = type === "days_on_market_mean";
  const isHomeSalesSelected = type === "home_sales_cumulative_mean";
  const isPpfsGrowthSelected = type === "ppsf_Growth_mean";
  const isDomGrowthSelected = type === "dom_growth_months";
  const isHsGrowthSelected = type === "hs_growth_months";
  const feature = event.feature;
  const factoryCentre1 = feature.getProperty("factoryCentre1");
  const factoryCentre2 = feature.getProperty("factoryCentre2");
  const factoryCentre3 = feature.getProperty("factoryCentre3");
  const distanceFromFactoryCentre1 = feature.getProperty(
    "distanceFromFactoryCentre1"
  );
  const distanceFromFactoryCentre2 = feature.getProperty(
    "distanceFromFactoryCentre2"
  );
  const distanceFromFactoryCentre3 = feature.getProperty(
    "distanceFromFactoryCentre3"
  );
  const ppsf = feature.getProperty("ppsf");
  const expectedPpsfMean = feature.getProperty("expectedPpsfMean");
  const ppsfGrowthMean = feature.getProperty("ppsfGrowthMean");
  const homeSaleCumulativeMean = feature.getProperty("homeSaleCumulativeMean");
  const daysOnMarketMean = feature.getProperty("daysOnMarketMean");
  const highExpectedResults = feature.getProperty("highExpectedResults");
  const medianSalePricePerHouse = feature.getProperty(
    "medianSalePricePerHouse"
  );
  const zip = feature.getProperty("zipCode");
  const city = feature.getProperty("city");
  const county = feature.getProperty("county");
  const state = feature.getProperty("state");
  const hsGrowth = feature.getProperty("hsGrowth");
  const domGrowth = feature.getProperty("domGrowth");
  const expectedHomeSales3Months = feature.getProperty(
    "expectedHomeSales3Months"
  );

  console.log(feature)
  const totalHousesHolds2018 = feature.getProperty("totalHousesHolds2018");
  const totalHousesHolds2023 = feature.getProperty("totalHousesHolds2023");
  const houseHoldsGrowth1 = feature.getProperty("houseHoldsGrowth1");
  const houseHoldsGrowth5 = feature.getProperty("houseHoldsGrowth5");
  const totalPopulation2018 = feature.getProperty("totalPopulation2018");
  const totalPopulation2023 = feature.getProperty("totalPopulation2023");
  const populationGrowth1 = feature.getProperty("populationGrowth1");
  const populationsGrowth5 = feature.getProperty("populationsGrowth5");
  if (email.split("@")[1] === "onxhomes.com") {
    return `<div id='map-tooltip'>
    <div class='nav-bar'>
        <div class='nav-title'>
            <span>Latest Historical Data Till: ${selectedQuarter}</span>
        </div>        
    </div>
    <div class='nav-container'>
        <div class='nav-container-col'>
            <div class='nav-container-title'>ZipCode</div>
            <div class='nav-container-value'>${zip}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title'>City</div>
            <div class='nav-container-value'>${city}</div>
        </div>  
        <div class='nav-container-col'>
            <div class='nav-container-title'>County</div>
            <div class='nav-container-value'>${county}</div>
        </div>   
        <div class='nav-container-col'>
            <div class='nav-container-title'>State</div>
            <div class='nav-container-value'>${state}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title'>Factory Centre(Zip code) (Red)</div>
            <div class='nav-container-value' style='color: #FD7567;'>${factoryCentre1}</div>
        </div>                        
        <div class='nav-container-col'>
            <div class='nav-container-title'>Distance from Factory Centre (Red)</div>
            <div class='nav-container-value' style='color: #FD7567;'>${distanceFromFactoryCentre1}</div>
        </div>    
        <div class='nav-container-col'>
            <div class='nav-container-title'>Factory Centre(Zip code) (Blue)</div>
            <div class='nav-container-value' style='color: #6991FC;'>${factoryCentre2}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title'>Distance from Factory Centre (Blue)</div>
            <div class='nav-container-value' style='color: #6991FC;'>${distanceFromFactoryCentre2}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title'>Factory Centre(Zip code) (Green)</div>
            <div class='nav-container-value' style='color: #00E64C;'>${factoryCentre3}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title'>Distance from Factory Centre (Green)</div>
            <div class='nav-container-value' style='color: #00E64C;'>${distanceFromFactoryCentre3}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title'>Median Present PPSF ($)</div>
            <div class='nav-container-value'>${ppsf}</div>
        </div>  
        <div class='nav-container-col'>
            <div class='nav-container-title'>Median Expected PPSF ($)</div>
            <div class='nav-container-value'>${expectedPpsfMean}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title ${
              isPpfsGrowthSelected ? "bold" : ""
            }'>Median PPSF Growth %</div>
            <div class='nav-container-value ${
              isPpfsGrowthSelected ? "bold" : ""
            }'>${ppsfGrowthMean}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title'>Median Sale Price Per House ($)</div>
            <div class='nav-container-value'>${medianSalePricePerHouse}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title ${
              isHomeSalesSelected ? "bold" : ""
            }'>Median Cummulative Home Sales</div>
            <div class='nav-container-value ${
              isHomeSalesSelected ? "bold" : ""
            }'>${homeSaleCumulativeMean}</div>
        </div>  
        <div class='nav-container-col'>
            <div class='nav-container-title ${
              isDaysOnMarketSelected ? "bold" : ""
            }'>Mean Days on Market</div>
            <div class='nav-container-value ${
              isDaysOnMarketSelected ? "bold" : ""
            }'>${daysOnMarketMean}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title ${
              isExpectedReturnSelected ? "bold" : ""
            }'>Total Market Expected Volume (Million $) for ${getQuarter(
      selectedMonth
    )} Quarter</div>
            <div class='nav-container-value ${
              isExpectedReturnSelected ? "bold" : ""
            }'>${highExpectedResults}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title ${
              isDomGrowthSelected ? "bold" : ""
            }'>Days On Market Growth</div>
            <div class='nav-container-value ${
              isDomGrowthSelected ? "bold" : ""
            }'>${domGrowth}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title ${
              isHsGrowthSelected ? "bold" : ""
            }'>Home Sales Growth</div>
            <div class='nav-container-value ${
              isHsGrowthSelected ? "bold" : ""
            }'>${hsGrowth}</div>
        </div>   
        <div class='nav-container-col'>
            <div class='nav-container-title'>Expected Homesales for ${getQuarter(
              selectedMonth
            )} Quarter</div>
            <div class='nav-container-value'>${
              expectedHomeSales3Months || "-"
            }</div>
        </div>                     
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total House Holds In 2017</div>
            <div class='nav-container-value'>${
              totalHousesHolds2018 || "-"
            }</div>
        </div>   
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total House Holds In 2023</div>
            <div class='nav-container-value'>${
              totalHousesHolds2023 || "-"
            }</div>
        </div>                  
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total House Holds Growth In 1 Year</div>
            <div class='nav-container-value'>${houseHoldsGrowth1 || "-"}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total House Holds Growth In 5 Years</div>
            <div class='nav-container-value'>${houseHoldsGrowth5 || "-"}</div>
        </div> 
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total Population In 2018</div>
            <div class='nav-container-value'>${totalPopulation2018 || "-"}</div>
        </div>   
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total Population In 2023</div>
            <div class='nav-container-value'>${totalPopulation2023 || "-"}</div>
        </div>                  
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total Population Growth In 1 Year</div>
            <div class='nav-container-value'>${populationGrowth1 || "-"}</div>
        </div>
        <div class='nav-container-col'>
            <div class='nav-container-title'>Total Population Growth In 5 Years</div>
            <div class='nav-container-value'>${populationsGrowth5 || "-"}</div>
        </div>                  
    </div>
</div>`;
  }

  return `<div id='map-tooltip'>
                <div class='nav-bar'>
                    <div class='nav-title'>
                        <span>Latest Historical Data Till: ${selectedQuarter}</span>
                    </div>        
                </div>
                <div class='nav-container'>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>ZipCode</div>
                        <div class='nav-container-value'>${zip}</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>City</div>
                        <div class='nav-container-value'>${city}</div>
                    </div>  
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>County</div>
                        <div class='nav-container-value'>${county}</div>
                    </div>   
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>State</div>
                        <div class='nav-container-value'>${state}</div>
                    </div> 
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Median Present PPSF ($)</div>
                        <div class='nav-container-value'>${ppsf}</div>
                    </div>  
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Median Expected PPSF ($)</div>
                        <div class='nav-container-value'>${expectedPpsfMean}</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title ${
                          isPpfsGrowthSelected ? "bold" : ""
                        }'>Median PPSF Growth %</div>
                        <div class='nav-container-value ${
                          isPpfsGrowthSelected ? "bold" : ""
                        }'>${ppsfGrowthMean}</div>
                    </div> 
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Median Sale Price Per House ($)</div>
                        <div class='nav-container-value'>${medianSalePricePerHouse}</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title ${
                          isHomeSalesSelected ? "bold" : ""
                        }'>Median Cummulative Home Sales</div>
                        <div class='nav-container-value ${
                          isHomeSalesSelected ? "bold" : ""
                        }'>${homeSaleCumulativeMean}</div>
                    </div>  
                    <div class='nav-container-col'>
                        <div class='nav-container-title ${
                          isDaysOnMarketSelected ? "bold" : ""
                        }'>Mean Days on Market</div>
                        <div class='nav-container-value ${
                          isDaysOnMarketSelected ? "bold" : ""
                        }'>${daysOnMarketMean}</div>
                    </div> 
                    <div class='nav-container-col'>
                        <div class='nav-container-title ${
                          isExpectedReturnSelected ? "bold" : ""
                        }'>Total Market Expected Volume (Million $) for ${getQuarter(
    selectedMonth
  )} Quarter</div>
                        <div class='nav-container-value ${
                          isExpectedReturnSelected ? "bold" : ""
                        }'>${highExpectedResults}</div>
                    </div> 
                    <div class='nav-container-col'>
                        <div class='nav-container-title ${
                          isDomGrowthSelected ? "bold" : ""
                        }'>Days On Market Growth</div>
                        <div class='nav-container-value ${
                          isDomGrowthSelected ? "bold" : ""
                        }'>${domGrowth}</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title ${
                          isHsGrowthSelected ? "bold" : ""
                        }'>Home Sales Growth</div>
                        <div class='nav-container-value ${
                          isHsGrowthSelected ? "bold" : ""
                        }'>${hsGrowth}</div>
                    </div>   
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Expected Homesales for ${getQuarter(
                          selectedMonth
                        )} Quarter</div>
                        <div class='nav-container-value'>${
                          expectedHomeSales3Months || "-"
                        }</div>
                    </div>                     
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total House Holds In 2018</div>
                        <div class='nav-container-value'>${
                          totalHousesHolds2018 || "-"
                        }</div>
                    </div>   
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total House Holds In 2023</div>
                        <div class='nav-container-value'>${
                          totalHousesHolds2023 || "-"
                        }</div>
                    </div>                  
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total House Holds Growth In 1 Year</div>
                        <div class='nav-container-value'>${
                          houseHoldsGrowth1 || "-"
                        }</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total House Holds Growth In 5 Years</div>
                        <div class='nav-container-value'>${
                          houseHoldsGrowth5 || "-"
                        }</div>
                    </div> 
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total Population In 2018</div>
                        <div class='nav-container-value'>${
                          totalPopulation2018 || "-"
                        }</div>
                    </div>   
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total Population In 2023</div>
                        <div class='nav-container-value'>${
                          totalPopulation2023 || "-"
                        }</div>
                    </div>                  
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total Population Growth In 1 Year</div>
                        <div class='nav-container-value'>${
                          populationGrowth1 || "-"
                        }</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Total Population Growth In 5 Years</div>
                        <div class='nav-container-value'>${
                          populationsGrowth5 || "-"
                        }</div>
                    </div>                  
                </div>
            </div>`;
};

const getQuarter = (month) => {
  let quarter = Math.floor((parseInt(month) - 1) / 3) + 1;
  quarter = quarter + 1;
  if (quarter >= 11 && quarter <= 13) {
    return quarter + "th";
  }
  switch (quarter % 10) {
    case 1:
      return quarter + "st";
    case 2:
      return quarter + "nd";
    case 3:
      return quarter + "rd";
    default:
      return quarter + "th";
  }
};

export const progressBarLabel = (type) => {
  let heading = "Total Market Expected Volume (Million $)";
  switch (type) {
    case "days_on_market_mean":
      heading = "Days on Market (Mean)";
      break;
    case "home_sales_cumulative_mean":
      heading = "Home Sales Cumulative (Mean)";
      break;
    case "ppsf_Growth_mean":
      heading = "PPSF Growth (Mean)";
      break;
    case "dom_growth_months":
      heading = "Days On Market Growth";
      break;
    case "hs_growth_months":
      heading = "Home Sales Change";
      break;
    default:
      heading = "Total Market Expected Volume (Million $)";
  }

  return `<span>${heading}</span><br/><span id='highlight'>Click on any colored zipcode for more information.</span>`;
};





export const buildContent = (
  property,
  className,
  regionFactory,
  type,
  markerAdditionalInfo,
  email
) => {
  const isPpfsGrowthSelected = type === "ppsf_Growth_mean";
  const factoryCentre1 = property.factoryCentre1;
  const factoryCentre2 = property.factoryCentre2;
  const factoryCentre3 = property.factoryCentre3;
  const distanceFromFactoryCentre1 = property.distanceFromFactoryCentre1;
  const distanceFromFactoryCentre2 = property.distanceFromFactoryCentre2;
  const distanceFromFactoryCentre3 = property.distanceFromFactoryCentre3;
  const ppsf = property.ppsf;
  const expectedPpsfMean = property.expectedPpsfMean;
  const ppsfGrowthMean = property.ppsfGrowthMean;
  const zip = property.zip;
  const state = property.state;
  const markerDetails = markerAdditionalInfo[regionFactory - 1];
  const markerTotalHousesHolds2018 = (
    markerDetails.markerTotalHousesHolds2018 / markerDetails.count
  ).toFixed(2);
  const markerTotalHousesHolds2021 = (
    markerDetails.markerTotalHousesHolds2021 / markerDetails.count
  ).toFixed(2);
  const markerTotalHousesHolds2023 = (
    markerDetails.markerTotalHousesHolds2023 / markerDetails.count
  ).toFixed(2);
  const markerHouseHoldsGrowth1 = (
    markerDetails.markerHouseHoldsGrowth1 / markerDetails.count
  ).toFixed(2);
  const markerHouseHoldsGrowth5 = (
    markerDetails.markerHouseHoldsGrowth5 / markerDetails.count
  ).toFixed(2);
  const markerTotalPopulation2017 = (
    markerDetails.markerTotalPopulation2017 / markerDetails.count
  ).toFixed(2);
  const markerTotalPopulation2021 = (
    markerDetails.markerTotalPopulation2021 / markerDetails.count
  ).toFixed(2);
  const markerTotalPopulation2023 = (
    markerDetails.markerTotalPopulation2023 / markerDetails.count
  ).toFixed(2);
  const markerPopulationGrowth1 = (
    markerDetails.markerPopulationGrowth1 / markerDetails.count
  ).toFixed(2);
  const markerPopulationsGrowth5 = (
    markerDetails.markerPopulationsGrowth5 / markerDetails.count
  ).toFixed(2);
  if (email.split("@")[1] === "onxhomes.com") {
    return `<div id='map-tooltip'>
    <div class='nav-bar'>
      <div class='nav-title'>
        <span><i aria-hidden='true' class='fa fa-solid fa-industry fa-lg ${className}' title='Factory'></i><span class='fa-sr-only'>Factory</span>&nbsp; Factory </span>
        <span>Cluster ${regionFactory}</span>
        <span></span>
      </div>        
    </div>
    <div class='nav-container'>
      <div class='nav-container-col'>
        <div class='nav-container-title'>ZipCode</div>
        <div class='nav-container-value'>${zip}</div>
      </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>State</div>
        <div class='nav-container-value'>${state}</div>
      </div> 
      <div class='nav-container-col'>
        <div class='nav-container-title'>Factory Centre(Zip code) (Red)</div>
        <div class='nav-container-value' style='color: #FD7567;'>${factoryCentre1}</div>
      </div>                        
      <div class='nav-container-col'>
        <div class='nav-container-title'>Distance from Factory Centre (Red)</div>
        <div class='nav-container-value' style='color: #FD7567;'>${distanceFromFactoryCentre1}</div>
      </div>    
      <div class='nav-container-col'>
        <div class='nav-container-title'>Factory Centre(Zip code) (Blue)</div>
        <div class='nav-container-value' style='color: #6991FC;'>${factoryCentre2}</div>
      </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>Distance from Factory Centre (Blue)</div>
        <div class='nav-container-value' style='color: #6991FC;'>${distanceFromFactoryCentre2}</div>
      </div> 
      <div class='nav-container-col'>
        <div class='nav-container-title'>Factory Centre(Zip code) (Green)</div>
        <div class='nav-container-value' style='color: #00E64C;'>${factoryCentre3}</div>
      </div> 
      <div class='nav-container-col'>
        <div class='nav-container-title'>Distance from Factory Centre (Green)</div>
        <div class='nav-container-value' style='color: #00E64C;'>${distanceFromFactoryCentre3}</div>
      </div> 
      <div class='nav-container-col'>
        <div class='nav-container-title'>Median Present PPSF ($)</div>
        <div class='nav-container-value'>${ppsf}</div>
      </div>  
      <div class='nav-container-col'>
        <div class='nav-container-title'>Median Expected PPSF ($)</div>
        <div class='nav-container-value'>${expectedPpsfMean}</div>
      </div>
      <div class='nav-container-col'>
        <div class='nav-container-title ${
          isPpfsGrowthSelected ? "bold" : ""
        }'>Median PPSF Growth % </div>
        <div class='nav-container-value ${
          isPpfsGrowthSelected ? "bold" : ""
        }'>${ppsfGrowthMean}</div>
      </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>Average House Holds In 2018</div>
        <div class='nav-container-value'>${markerTotalHousesHolds2018}</div>
      </div>
   
      <div class='nav-container-col'>
      <div class='nav-container-title'>Average House Holds In 2023</div>
      <div class='nav-container-value'>${markerTotalHousesHolds2023}</div>
    </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>Average House Holds Growth In 1 Year</div>
        <div class='nav-container-value'>${markerHouseHoldsGrowth1}</div>
      </div> 
      <div class='nav-container-col'>
        <div class='nav-container-title'>Average House Holds Growth In 5 Years</div>
        <div class='nav-container-value'>${markerHouseHoldsGrowth5}</div>
      </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>Average Population In 2017</div>
        <div class='nav-container-value'>${markerTotalPopulation2017}</div>
      </div>
    
      <div class='nav-container-col'>
      <div class='nav-container-title'>Average Population In 2023</div>
      <div class='nav-container-value'>${markerTotalPopulation2023}</div>
    </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>Average Population Growth In 1 Year</div>
        <div class='nav-container-value'>${markerPopulationGrowth1}</div>
      </div>
      <div class='nav-container-col'>
        <div class='nav-container-title'>Average Population Growth In 5 Years</div>
        <div class='nav-container-value'>${markerPopulationsGrowth5}</div>
      </div>                       
    </div>
  </div>`;
  }

  return `<div id='map-tooltip'>
            <div class='nav-bar'>
              <div class='nav-title'>
                <span><i aria-hidden='true' class='fa fa-solid fa-industry fa-lg ${className}' title='Factory'></i><span class='fa-sr-only'>Factory</span>&nbsp; Factory </span>
                <span>Cluster ${regionFactory}</span>
                <span></span>
              </div>        
            </div>
            <div class='nav-container'>
              <div class='nav-container-col'>
                <div class='nav-container-title'>ZipCode</div>
                <div class='nav-container-value'>${zip}</div>
              </div>
              <div class='nav-container-col'>
                <div class='nav-container-title'>State</div>
                <div class='nav-container-value'>${state}</div>
              </div>       
              <div class='nav-container-col'>
                <div class='nav-container-title'>Median Present PPSF ($)</div>
                <div class='nav-container-value'>${ppsf}</div>
              </div>  
              <div class='nav-container-col'>
                <div class='nav-container-title'>Median Expected PPSF ($)</div>
                <div class='nav-container-value'>${expectedPpsfMean}</div>
              </div>
              <div class='nav-container-col'>
                <div class='nav-container-title ${
                  isPpfsGrowthSelected ? "bold" : ""
                }'>Median PPSF Growth % </div>
                <div class='nav-container-value ${
                  isPpfsGrowthSelected ? "bold" : ""
                }'>${ppsfGrowthMean}</div>
              </div>
              <div class='nav-container-col'>
                <div class='nav-container-title'>Average House Holds In 2018</div>
                <div class='nav-container-value'>${markerTotalHousesHolds2018}</div>
              </div>
           
              <div class='nav-container-col'>
              <div class='nav-container-title'>Average House Holds In 2023</div>
              <div class='nav-container-value'>${markerTotalHousesHolds2023}</div>
            </div>
              <div class='nav-container-col'>
                <div class='nav-container-title'>Average House Holds Growth In 1 Year</div>
                <div class='nav-container-value'>${markerHouseHoldsGrowth1}</div>
              </div> 
              <div class='nav-container-col'>
                <div class='nav-container-title'>Average House Holds Growth In 5 Years</div>
                <div class='nav-container-value'>${markerHouseHoldsGrowth5}</div>
              </div>
              <div class='nav-container-col'>
                <div class='nav-container-title'>Average Population In 2017</div>
                <div class='nav-container-value'>${markerTotalPopulation2017}</div>
              </div>
            
              <div class='nav-container-col'>
              <div class='nav-container-title'>Average Population In 2023</div>
              <div class='nav-container-value'>${markerTotalPopulation2023}</div>
            </div>
              <div class='nav-container-col'>
                <div class='nav-container-title'>Average Population Growth In 1 Year</div>
                <div class='nav-container-value'>${markerPopulationGrowth1}</div>
              </div>
              <div class='nav-container-col'>
                <div class='nav-container-title'>Average Population Growth In 5 Years</div>
                <div class='nav-container-value'>${markerPopulationsGrowth5}</div>
              </div>                       
            </div>
          </div>`;
};

export const sortLimitedData = (data, key, limit) => {
  if (limit === "All") {
    if (REVERSE_SCALE.includes(key))
      return data.sort((a, b) => parseFloat(a[key]) - parseFloat(b[key]));
    else return data.sort((a, b) => parseFloat(b[key]) - parseFloat(a[key]));
  } else {
    if (REVERSE_SCALE.includes(key))
      return data
        .sort((a, b) => parseFloat(a[key]) - parseFloat(b[key]))
        .slice(0, limit);
    else
      return data
        .sort((a, b) => parseFloat(b[key]) - parseFloat(a[key]))
        .slice(0, limit);
  }
};

export const generateMetroPopupContent = (event, msa) => {
  const feature = event.feature;
  const city = feature.getProperty("city");
  const county = feature.getProperty("county");
  const state = feature.getProperty("state");
  const zipCode = feature.getProperty("zipCode");

  return `<div id='map-tooltip'>
            <div class='nav-bar'>
                <div class='nav-title'><span>MSA: ${msa}</span></div>        
            </div>
            <div class='nav-container'>
                <div class='nav-container-col'>
                    <div class='nav-container-title'>ZipCode</div>
                    <div class='nav-container-value'>${zipCode}</div>
                </div>
                <div class='nav-container-col'>
                    <div class='nav-container-title'>City</div>
                    <div class='nav-container-value'>${city}</div>
                </div>  
                <div class='nav-container-col'>
                    <div class='nav-container-title'>County</div>
                    <div class='nav-container-value'>${county}</div>
                </div>   
                <div class='nav-container-col'>
                    <div class='nav-container-title'>State</div>
                    <div class='nav-container-value'>${state}</div>
                </div>                   
            </div>
        </div>`;
};

export const stringToNumber = (number) => {
  try {
    const num = parseFloat(number);
    if (isNaN(num)) {
      return 0.0;
    } else {
      return num;
    }
  } catch (e) {
    return 0.0;
  }
};